<template>
<nav>
  <ul class="nav nav-pills">
    <li>
      <router-link :to="{ name: 'newsletter_types' }">
        Newsletter Types
      </router-link>
    </li>
    <li>
      <router-link :to="{ name: 'create_newsletter_type' }">
        Add Newsletter Type
      </router-link>
    </li>
    <li v-if="newsletterTypeId && this.$parent.$parent.role === 'admin'">
      <router-link
        :to="{
          name: 'edit_newsletter_type', params: {
            newsletterTypeId: newsletterTypeId
          }
        }"
      >
        Edit Newsletter Type
      </router-link>
    </li>
    <li v-if="!newsletterTypeId">
      <router-link :to="{
        name: 'newsletters'
      }">
        All Newsletters
      </router-link>
    </li>
    <li v-if="newsletterTypeId">
      <router-link :to="{
        name: 'newsletter_type_newsletters',
        params: {
          newsletterTypeId: newsletterTypeId
        }
      }">
        Newsletters
      </router-link>
    </li>
    <li v-if="newsletterTypeId">
      <router-link :to="{ name: 'newsletter_type_subscribers', params: { newsletterTypeId: newsletterTypeId } }">
        Subscribers
      </router-link>
    </li>
    <li v-if="newsletterTypeId">
      <router-link
        :to="{
          name: 'create_newsletter_type_subscriber',
          params: {
            newsletterTypeId: newsletterTypeId
          }
        }"
      >
        Add Subscriber
      </router-link>
    </li>
    <li v-if="newsletterTypeId">
      <router-link :to="{ name: 'import_newsletter_type_subscribers',
        params: { newsletterTypeId: newsletterTypeId }
      }">
        Import Subscribers
      </router-link>
    </li>
  </ul>
</nav>
</template>

<script>
export default {
  props: [
    'newsletterTypeId', 'newsletterTypeSubscriberId'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterTypeNav.vue